import { render, staticRenderFns } from "./userDataDelete.vue?vue&type=template&id=1fbb2f71&"
import script from "./userDataDelete.vue?vue&type=script&lang=js&"
export * from "./userDataDelete.vue?vue&type=script&lang=js&"
import style0 from "./userDataDelete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports